import { FullWorkflow } from "@components/WorkflowCard/types";
import { StepType, WORKFLOW_ACTIONS } from "@typings/api-models";

const actionSubtext = (workflow: FullWorkflow): string => {
  const actionStep = workflow.steps.find((step) => step.type === StepType.ACTION);
  if (actionStep?.eventName === WORKFLOW_ACTIONS.SEND_MESSAGE) {
    return 'Send message';
  }
  if (actionStep?.eventName === WORKFLOW_ACTIONS.SEND_EMAIL) {
    return 'Send email';
  }
  return 'Add action';
};

export default actionSubtext;